/* dementedworld product page behaviour — loaded by sections/main-product.liquid.
   Reads per-product data from a <script class="dw-pdp__data"> JSON blob inside
   each .dw-pdp container so this file can stay static (no Liquid). */
(function () {
  function money(fmt, cents) {
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toLocaleString('en', { minimumFractionDigits: 2 }))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toLocaleString('en'))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, (cents / 100).toLocaleString('en', { minimumFractionDigits: 2 }));
  }

  // Global (window/document) listeners bound ONCE for the whole page. Previously these lived
  // inside initOne, so every shopify:section:load re-init (editor + section reloads) stacked
  // another un-removed window 'resize' + document 'keydown' - a listener leak. Both re-query
  // the live DOM at event time, so one binding serves every .dw-pdp on the page.
  var GLOBAL_BOUND = false;
  function bindGlobal() {
    if (GLOBAL_BOUND) return;
    GLOBAL_BOUND = true;
    window.addEventListener('resize', function () {
      document.querySelectorAll('.dw-pdp__acc-item.is-open .dw-pdp__acc-body').forEach(function (b) {
        b.style.maxHeight = 'none';
        var h = b.scrollHeight;
        b.style.maxHeight = h + 'px';
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var sc = document.querySelector('[data-dw-sc]');
      if (sc && !sc.hidden && typeof sc._dwClose === 'function') sc._dwClose();
    });
  }

  function initOne(root) {
    if (root.dataset.dwInit) return;
    root.dataset.dwInit = '1';
    bindGlobal();

    var data = {};
    var dataEl = root.querySelector('.dw-pdp__data');
    if (dataEl) { try { data = JSON.parse(dataEl.textContent); } catch (e) { data = {}; } }
    var fmt = data.money_format || '{{amount}}';
    var ADD = data.add || 'ADD TO CART';
    var SOLD = data.sold || 'SOLD OUT';
    var variants = data.variants || [];
    var STOCK = data.stock || null;
    // "N LEFT" for a variant, only when its stock is tracked, finite and at/under the threshold
    function stockText(id) {
      if (!STOCK || !STOCK.show || !STOCK.inv) return '';
      var info = STOCK.inv[id];
      if (!info || !info.m || info.p !== 'deny') return '';
      if (info.q > 0 && info.q <= STOCK.threshold) return (STOCK.text || 'ONLY [n] REMAINING').replace('[n]', info.q);
      return '';
    }

    /* ---- variant selection ---- */
    var form = root.querySelector('.dw-pdp__form');
    var select = root.querySelector('select[name="id"]');
    var priceEl = root.querySelector('[data-dw-price]');
    var addBtn = root.querySelector('[data-dw-add]');
    if (form && select) {
      var chosen = [];
      root.querySelectorAll('[data-dw-option]').forEach(function (row) {
        var sel = row.querySelector('.is-selected');
        chosen[+row.getAttribute('data-dw-option')] = sel ? sel.getAttribute('data-val') : null;
      });
      root.querySelectorAll('.dw-pdp__val').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var oi = +btn.getAttribute('data-oi');
          chosen[oi] = btn.getAttribute('data-val');
          btn.parentNode.querySelectorAll('.dw-pdp__val').forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-checked', 'false'); });
          btn.classList.add('is-selected');
          btn.setAttribute('aria-checked', 'true');
          var m = variants.find(function (vt) { return vt.options.every(function (o, i) { return chosen[i] == null || o === chosen[i]; }); });
          if (m) {
            select.value = m.id;
            if (priceEl) priceEl.textContent = money(fmt, m.price);
            if (addBtn) {
              addBtn.dataset.compareAt = (m.compare_at_price != null ? m.compare_at_price : '');
              var labelEl = addBtn.querySelector('[data-dw-label]') || addBtn.querySelector('span');
              var stockEl = addBtn.querySelector('[data-dw-stock]');
              if (m.available) { addBtn.removeAttribute('disabled'); if (labelEl) labelEl.textContent = ADD; }
              else { addBtn.setAttribute('disabled', ''); if (labelEl) labelEl.textContent = SOLD; }
              if (stockEl) stockEl.textContent = m.available ? stockText(m.id) : '';
            }
          }
        });
      });
    }

    /* ---- accordions: one open at a time; close current fully, then open next ---- */
    var items = [].slice.call(root.querySelectorAll('.dw-pdp__acc-item'));
    var busy = false;
    function setOpen(item, open, cb) {
      var body = item.querySelector('.dw-pdp__acc-body');
      var head = item.querySelector('.dw-pdp__acc-head');
      if (open) {
        item.classList.add('is-open');
        head.setAttribute('aria-expanded', 'true');
        body.style.maxHeight = body.scrollHeight + 'px';
      } else {
        item.classList.remove('is-open');
        head.setAttribute('aria-expanded', 'false');
        body.style.maxHeight = body.scrollHeight + 'px';
        void body.offsetHeight;
        body.style.maxHeight = '0px';
      }
      if (cb) setTimeout(cb, 430);
    }
    items.forEach(function (item) {
      item.querySelector('.dw-pdp__acc-head').addEventListener('click', function () {
        if (busy) return;
        if (item.classList.contains('is-open')) { setOpen(item, false); return; }
        var openOne = null;
        items.forEach(function (o) { if (o.classList.contains('is-open')) openOne = o; });
        if (openOne) {
          busy = true;
          setOpen(openOne, false, function () { setOpen(item, true, function () { busy = false; }); });
        } else {
          setOpen(item, true);
        }
      });
    });
    /* accordion resize re-measure is handled once in bindGlobal() (see top) */

    /* ---- size chart: slide-in panel (right, half screen) with tabs + unit toggle ---- */
    var sc = document.querySelector('[data-dw-sc]');
    if (sc) {
      // Focus moves into the panel on open and back to the trigger on close (a11y; invisible
      // to mouse users). Escape-to-close is bound once in bindGlobal() to avoid a leak.
      var scLastFocus = null;
      var openSc = function () {
        scLastFocus = document.activeElement;
        sc.hidden = false;
        requestAnimationFrame(function () {
          sc.classList.add('is-open');
          var panel = sc.querySelector('.dw-sc__panel') || sc;
          if (!panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '-1');
          panel.focus({ preventScroll: true });
        });
      };
      var closeSc = function () {
        sc.classList.remove('is-open');
        setTimeout(function () { sc.hidden = true; }, 400);
        if (scLastFocus && typeof scLastFocus.focus === 'function') { try { scLastFocus.focus({ preventScroll: true }); } catch (e) {} }
        scLastFocus = null;
      };
      sc._dwClose = closeSc;
      root.querySelectorAll('[data-dw-chart]').forEach(function (b) { b.addEventListener('click', openSc); });
      sc.querySelectorAll('[data-dw-close]').forEach(function (c) { c.addEventListener('click', closeSc); });
      var scTab = '0', scUnit = 'cm', scUnits = sc.querySelector('[data-dw-units]');
      var scRender = function () {
        sc.querySelectorAll('.dw-sc__pane').forEach(function (p) {
          p.hidden = !(p.getAttribute('data-dw-pane') === scTab && (scTab !== '0' || p.getAttribute('data-dw-u') === scUnit));
        });
        if (scUnits) scUnits.style.display = scTab === '0' ? '' : 'none';
        sc.querySelectorAll('[data-dw-tab]').forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-dw-tab') === scTab); });
        sc.querySelectorAll('[data-dw-unit]').forEach(function (u) { u.classList.toggle('is-active', u.getAttribute('data-dw-unit') === scUnit); });
      };
      sc.querySelectorAll('[data-dw-tab]').forEach(function (t) { t.addEventListener('click', function () { scTab = t.getAttribute('data-dw-tab'); scRender(); }); });
      sc.querySelectorAll('[data-dw-unit]').forEach(function (u) { u.addEventListener('click', function () { scUnit = u.getAttribute('data-dw-unit'); scRender(); }); });
      scRender();
    }

    /* ---- mobile image counter: update "N \ total" on horizontal swipe ---- */
    var swipe = root.querySelector('[data-dw-swipe]');
    if (swipe) {
      // counter now lives in the (non-scrolling) wrapper that is swipe's parent,
      // so it stays put while the slides scroll; fall back to root if absent.
      var curEl = (swipe.parentNode || root).querySelector('[data-dw-cur]');
      var slides = swipe.querySelectorAll('.dw-pdp__slide');
      if (curEl && slides.length) {
        var ticking = false;
        var updateCounter = function () {
          var w = swipe.clientWidth || 1;
          var idx = Math.round(swipe.scrollLeft / w) + 1;
          if (idx < 1) idx = 1;
          if (idx > slides.length) idx = slides.length;
          curEl.textContent = idx;
          ticking = false;
        };
        swipe.addEventListener('scroll', function () {
          if (!ticking) { ticking = true; requestAnimationFrame(updateCounter); }
        }, { passive: true });
      }
    }
  }

  function init() { document.querySelectorAll('.dw-pdp').forEach(initOne); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) { (e.target.querySelectorAll ? e.target : document).querySelectorAll('.dw-pdp').forEach(initOne); });
})();
